import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import THDCustomer from '@thd-olt-global/thd-customer';
import { getHost } from './general';
import { newRelic } from './newRelic';

export const SsoRedirectForm = ({ ssoResponse, isUserInSsoSetupFlow }) => {
  useEffect(() => {
    document.getElementById('ssoLogonForm').submit();
  }, []);
  const isEcmEligibleCustomer = THDCustomer.isB2CCustomer;
  const addEcmRedirect = useConfigService('fs:ENABLE_ECM_REDIRECT_PARAMETER')
    && ssoResponse.siteId === 'PLCN_HOMEDEPOT'
    && (ssoResponse.processIndicator === 'savecard' || isUserInSsoSetupFlow);
  const ecmRedirectUrl = 'https://' + window.location.host + '/myaccount/ecmsavecard';

  if (addEcmRedirect) {
    newRelic(null, 'Sending ecmSaveCardReturnURL param');
  }

  return (
    <div>
      <form
        action={ssoResponse.url}
        method="POST"
        id="ssoLogonForm"
        name="ssoLogonForm"
      >
        <input
          name="siteId"
          type="hidden"
          value={ssoResponse.siteId}
        />
        <input name="langId" type="hidden" value="en_US" />
        <input
          name="partnerUserId"
          type="hidden"
          value={ssoResponse.userId ? ssoResponse.userId : ssoResponse.svocId}
        />
        <input
          name="accessToken"
          type="hidden"
          value={ssoResponse.accessToken}
        />
        <input
          name="processIndicator"
          type="hidden"
          value={ssoResponse.processIndicator}
        />
        <input
          name="partnerLoginFailureCount"
          type="hidden"
          value={ssoResponse.loginFailureCount}
        />
        <input
          name="partnerRedirectUrl"
          type="hidden"
          value={ssoResponse.redirectURL}
        />
        <input
          name="guuId"
          type="hidden"
          value={ssoResponse.guuid}
        />
        {ssoResponse.grantType && (
          <input
            name="grant_type"
            type="hidden"
            value={ssoResponse.grantType}
          />
        )}
        {ssoResponse.clientId && (
          <input
            name="client_id"
            type="hidden"
            value={ssoResponse.clientId}
          />
        )}
        {ssoResponse.scope && (
          <input
            name="scope"
            type="hidden"
            value={ssoResponse.scope}
          />
        )}
        {ssoResponse.accountId && (
          <input
            name="accountId"
            type="hidden"
            value={ssoResponse.accountId}
          />
        )}
        {ssoResponse.userId && ssoResponse.svocId && (
          <input
            name="partnerSvocId"
            type="hidden"
            value={ssoResponse.svocId}
          />
        )}
        {ssoResponse.savedPlcn && (
          <input
            name="savedPlcn"
            type="hidden"
            value={ssoResponse.savedPlcn}
          />
        )}
        {isUserInSsoSetupFlow && (
          <input
            name="ecmEligible"
            type="hidden"
            value={isEcmEligibleCustomer ? 'True' : 'False'}
          />
        )}
        {addEcmRedirect && (
          <input
            name="ecmSaveCardReturnURL"
            type="hidden"
            value={ecmRedirectUrl}
          />
        )}
      </form>
    </div>
  );
};

SsoRedirectForm.propTypes = {
  ssoResponse: PropTypes.object.isRequired, // eslint-disable-line
  isUserInSsoSetupFlow: PropTypes.bool.isRequired,
};
